<!-- Layout simplificado: solo contenedor para router-outlet -->
<!-- El header y menú de usuario ahora están en ChatbotComponent -->
<div class="h-screen flex flex-col bg-gray-50 overflow-hidden">
  <main class="flex-1 overflow-hidden">
    <router-outlet></router-outlet>
  </main>
</div>
